import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import UsuarioPerfil from '../usuarioPerfil/usuarioPerfil';
import Usuario from '../usuario/usuario';
import Empresa from '../empresa/empresa';
import Fornecedor from '../fornecedor/fornecedor';
import Veiculo from '../veiculo/veiculo';
import UnidadeMedida from '../unidadeMedida/unidadeMedida';
import Produto from '../produto/produto';
import Cliente from '../cliente/cliente';
import AnalisePreco from '../analisePreco/analisePreco';
import PlanoConta from '../planoConta/planoConta';
import CentroCusto from '../centroCusto/centroCusto';
import Coleta from '../coleta/coleta';
import Aplicacao from '../aplicacao/aplicacao';
import Abastecimento from '../abastecimento/abastecimento';
import Manutencao from '../manutencao/manutencao';
import BrindeEntrada from '../brinde/brindeEntrada';
import BrindeSaida from '../brinde/brindeSaida';
import BrindeEstoque from '../brinde/brindeEstoque';
import ContaPagar from '../financeiro/contaPagar';
import ContaReceber from '../financeiro/contaReceber';
import DRE from '../dre/dre';
import Agenda from '../agenda/agenda';
import ContaCorrenteFuncionario from
	'../contaCorrenteFuncionario/contaCorrenteFuncionario';
import MinhaContaCorrente from
	'../contaCorrenteFuncionario/minhaContaCorrente';
import Ferramentas from '../ferramentas/ferramentas';

export default props => (
	<div id='id-content-wrapper' className='content-wrapper' style={{ paddingBottom: 0 }} >
		<Switch>
			<Route exact path='/' component={Dashboard} />
			<Route path='/usuarioPerfil' component={UsuarioPerfil} />
			<Route path='/usuario' component={Usuario} />
			<Route path='/empresa' component={Empresa} />
			<Route path='/fornecedor' component={Fornecedor} />
			<Route path='/veiculo' component={Veiculo} />
			<Route path='/unidadeMedida' component={UnidadeMedida} />
			<Route path='/produto' component={Produto} />
			<Route path='/produto' component={Produto} />
			<Route path='/cliente' component={Cliente} />
			<Route path='/analisePreco' component={AnalisePreco} />
			<Route path='/planoConta' component={PlanoConta} />
			<Route path='/centroCusto' component={CentroCusto} />
			<Route path='/coleta' component={Coleta} />
			<Route path='/aplicacao' component={Aplicacao} />
			<Route path='/abastecimento' component={Abastecimento} />
			<Route path='/manutencao' component={Manutencao} />
			<Route path='/brindeEntrada' component={BrindeEntrada} />
			<Route path='/brindeSaida' component={BrindeSaida} />
			<Route path='/brindeEstoque' component={BrindeEstoque} />
			<Route path='/contaPagar' component={ContaPagar} />
			<Route path='/contaReceber' component={ContaReceber} />
			<Route path='/dre' component={DRE} />
			<Route path='/agenda' component={Agenda} />
			<Route path='/contaCorrenteFuncionario' component={ContaCorrenteFuncionario} />
			<Route path='/minhaContaCorrente' component={MinhaContaCorrente} />
			<Route path='/ferramentas' component={Ferramentas} />
			<Redirect from='*' to='/' />
		</Switch>
	</div>
);
